<template>
  <div class="main-content">
    <section class="section">
      
      <div class="section-body">
        <!-- <button @click="Export" class="btn btn-primary">All Transaction Export</button> -->

      </div>
    </section>
  </div>
</template>

<script>
//import Breadcrumb from "@/components/Breadcrumb.vue";
import { mapGetters, mapActions } from "vuex";
import api from "@/api";

//import VueSlickGrid from "ls-vue-slickgrid";

export default {
  title: "Dashboard",
  access_code: "HOME_01",
  order: 99,
  icon: "fas fa-chart-bar",
  components: {
    //Breadcrumb,
    //VueSlickGrid
    
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"])
  },
  created() {
    this.$route.meta.access_code = "HOME";
    this.actionSetForceBlock(false);
  },

  mounted() {    
  },
  methods: {
    ...mapActions("grid", ["actionSetGridWithoutReload"]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),


  }
};
</script>
